import React from 'react'

import AgePreview from './AgeContent/AgePreview'
import GenderPreview from './GenderContent/GenderPreview'
import InterestsPreview from './InterestsContent/InterestsPreview'

const AudienceSectionPreview = () => {
  return (
    <p>
      <AgePreview />
      <GenderPreview />
      <InterestsPreview />
    </p>
  )
}

export default AudienceSectionPreview
